var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "User Premium Management" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "pb-6 flex items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "mr-2" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "search name or email" },
                            on: { change: _vm.searchUser },
                            model: {
                              value: _vm.filter.q,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "q", $$v)
                              },
                              expression: "filter.q"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mr-2 flex items-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "text-xs font-bold mr-2" },
                            [_vm._v("Duration:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Select Duration" },
                              model: {
                                value: _vm.grantDuration,
                                callback: function($$v) {
                                  _vm.grantDuration = $$v
                                },
                                expression: "grantDuration"
                              }
                            },
                            _vm._l(_vm.durationOptions, function(d) {
                              return _c("el-option", {
                                key: d.value,
                                attrs: { value: d.value, label: d.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: { label: "Apply" },
                        on: { clicked: _vm.searchUser }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "p-2" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "sync"] },
                            on: { click: _vm.reset }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableUser",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [20, 50, 100, 300]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom",
                          width: title.prop.width
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Type", align: "left", width: "120px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.type == 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "px-2 py-1 text-xs font-bold text-white bg-yellow-600 rounded"
                                    },
                                    [_vm._v("Premium")]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "px-2 py-1 text-xs font-bold text-white bg-gray-500 rounded"
                                    },
                                    [_vm._v("Free")]
                                  )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.isAdmin || _vm.isSuperAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            width: "180px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        scope.row.type == 0
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Set Premium",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-yellow-600 hover:bg-yellow-700 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setPremium(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "crown"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Revert to Free",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-red-600 hover:bg-red-700 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.revertPremium(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "undo"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3458124394
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddfd7e2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddfd7e2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/UsersPremium.vue
// module id = null
// module chunks = 